// "You're caught up" marker of the home timeline: the newest post loaded when the
// home timeline was last left. Kept per account in this browser.

import { compareId } from "flavours/glitch/compare_id";
import { me } from "flavours/glitch/initial_state";

const storageKey = () => `sloth-home-read:${me}`;

export const getReadMarker = () => {
  try {
    return window.localStorage.getItem(storageKey());
  } catch {
    return null;
  }
};

// Only moves forward, so an older id (e.g. after loading a gap) does not undo it.
export const setReadMarker = (id) => {
  if (!id || !me) {
    return;
  }

  const current = getReadMarker();
  if (current && compareId(id, current) <= 0) {
    return;
  }

  try {
    window.localStorage.setItem(storageKey(), id);
  } catch {
    // storage unavailable: no marker next time
  }
};

// The first post the reader has already seen, if newer posts come before it.
export const firstSeenId = (statusIds, marker) => {
  if (!marker) {
    return null;
  }

  const index = statusIds.findIndex(id => id !== null && compareId(id, marker) <= 0);
  // Only when real posts come before it; a gap (null) at the top does not count.
  const newerBefore = index > 0 && statusIds.slice(0, index).some(id => id !== null);
  return newerBefore ? statusIds.get(index) : null;
};
